import { render, staticRenderFns } from "./SpeakerSection.vue?vue&type=template&id=aa621f6e&scoped=true&"
import script from "./SpeakerSection.vue?vue&type=script&lang=js&"
export * from "./SpeakerSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa621f6e",
  null
  
)

export default component.exports